












import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Option} from '@/types/gripper';

@Component({
})

export default class OptionListItem extends Vue {

  @Prop(Object) public option!: Option;
  @Prop(Object) public currentOption!: Option;
  @Prop(Boolean) public isSidebarType!: boolean;

  get itemIsChecked() {
    if (!this.currentOption) {
      if (!this.isSidebarType && this.option.value === 'Geen Filter') {
        return this.option.value;
      }
      return false;
    } else {
      return this.currentOption.value === this.option.value;
    }
  }

  private checkItem(option: Option, isSidebarType: boolean) {
    if (!isSidebarType) {
      if (option.value !== 'Geen Filter') {
        this.$emit('onClickFilterOption', option, true);
      } else {
        this.$emit('onClickFilterOption', null, true);
      }
    } else {
      this.$emit('onClickChangeOption', option);
    }
  }

}
